module.exports = __webpack_public_path__ + "img/south-alabama-logo.5204715c.jpg";